import React from 'react';

// Toolbar filter rendered as a "Label: Value ▾" pill. A transparent native
// <select> is stretched over the pill so clicks open the real OS menu and
// keyboard and screen-reader behavior stay native. Any value other than
// `defaultValue` gets the highlighted active style.
const FilterSelect = ({ label, value, onChange, options, defaultValue = '' }) => {
  const selected = options.find((o) => o.value === value) || options[0];
  return (
    <div className={`filter-pill${value !== defaultValue ? ' filter-pill-active' : ''}`}>
      <span className="filter-pill-label">{label}:</span>
      <span className="filter-pill-value">{selected?.label}</span>
      <select
        className="filter-pill-select"
        aria-label={label}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
    </div>
  );
};

export default FilterSelect;
